import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  useBreakpointValue,
} from '@chakra-ui/react';
import { MerkatusLogo } from 'src/components/atoms/MerkatusLogo';
import BuildingImageUrl from 'src/assets/images/Building.png';
import { ContactForm } from 'src/components/molecules/ContactForm';
import { RevealOnScroll } from '../../atoms/RevealOnScroll';
import { imageZoomSx } from 'src/features/MP/utils/imageZoomSx';

const ContactPage = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box
      bg="white"
      color="text.darkBlue.900"
      pt={{ base: 16, md: 24 }}
      fontFamily="marketingPage">
      {/* Top Section */}
      <VStack spacing={4} px={4} textAlign="center" mb={16}>
        <Heading size="xl" fontFamily="marketingPage">
          LET&apos;S TALK
        </Heading>
        <Text fontSize="lg">
          Want to learn more about Merkatus.io?
          <br />
          Get in touch with our sales team—we&apos;d love to hear from you.
        </Text>
      </VStack>

      {/* Contact Card */}
      <RevealOnScroll>
        <Box px={4}>
          <Box
            maxW="lg"
            mx="auto"
            borderWidth="1px"
            borderRadius="16px"
            p={9}
            mb={24}
            boxShadow="md">
            <ContactForm
              title="Contact Sales"
              submitButtonText="Contact Sales"
            />
          </Box>
        </Box>
      </RevealOnScroll>

      {/* Location Section */}
      <RevealOnScroll>
        <Box py={24} px={4} bg={'lightGray'}>
          <HStack
            maxW="6xl"
            mx="auto"
            alignItems="flex-start"
            spacing={12}
            flexDir={isMobile ? 'column' : 'row'}>
            <VStack align="start" spacing={4} flex="1">
              <Heading size="xl" fontFamily="marketingPage">
                ALWAYS NEAR. <br /> ALWAYS THINKING AHEAD
              </Heading>
              <Text maxWidth={'451px'} fontSize={15} lineHeight={'24px'}>
                We&apos;re headquartered in Helsinki, Finland—but our tools
                empower teams worldwide.
              </Text>
            </VStack>

            <Box flex="1">
              <Box overflow="hidden" borderRadius="md">
                <Image
                  sx={imageZoomSx}
                  src={BuildingImageUrl}
                  alt="Merkatus Building"
                  objectFit="cover"
                  w="100%"
                  maxH="352px"
                  display="block"
                />
              </Box>
              <Box mt={4}>
                <MerkatusLogo theme="dark" clickable={false} />
                <Text fontSize={15} mt={4}>
                  Merkatus.io Oy, Helsinki, Finland
                </Text>
                <Text fontSize={15} mt={1}>
                  support@merkatus.io
                </Text>
              </Box>
            </Box>
          </HStack>
        </Box>
      </RevealOnScroll>
    </Box>
  );
};

export default ContactPage;
